import {
    LOGIN_USER,
    LOGOUT_USER,
    USER_BINANCE_ACCOUNT_INFO,
    USER_INFO
} from "../actions/constants";

const userDetails = {
    accountInfo: {
        accessToken: "",
        accountName: ""
    },
    balanceDetails: {
        feeTier: 0,
        updateTime: 0,
        multiAssetsMargin: false,
        totalInitialMargin: 0.0,
        totalMaintMargin: 0.0,
        totalWalletBalance: 0.0,
        totalUnrealizedProfit: 0.0,
        totalMarginBalance: 0.0,
        totalPositionInitialMargin: 0.0,
        totalOpenOrderInitialMargin: 0.0,
        totalCrossWalletBalance: 0.0,
        totalCrossUnPnl: 0.0,
        availableBalance: 0.0,
        maxWithdrawAmount: 0.0
    },
    openPositionsList: []
};

export const userInfo = (state = userDetails, { type, payload }) => {
    switch (type) {
        case USER_INFO:
            return { ...payload };

        case USER_BINANCE_ACCOUNT_INFO:
            return { ...payload };
        case LOGIN_USER:
            return { ...payload };
        case LOGOUT_USER:
            return { ...payload };
        default:
            return state;
    }
};
